import React from "react";
import BlueTag from "../../common/ui/BlueTag";
import Heading from "../../common/ui/Heading";
import Paragraph from "../../common/ui/Paragraph";
import Card from "./Card";
import layer from "../../../assets/images/webp/choose-us-layer.webp";
import leafImg from "../../../assets/images/svg/leaf-image-choose-us.svg";

const ChooseUs = () => {
  const list = [
    {
      title: "Tailored Strategies for Every Need",
      icon: "blue-circle-idea",
      description:
        "We analyze your unique challenges to craft solutions that drive efficiency, growth, and innovation across industries.",
    },
    {
      title: "Seamless Collaboration and Transparency",
      icon: "blue-circle-message",
      description:
        "We prioritize open communication and a collaborative approach, ensuring our clients are informed and empowered every step of the way.",
    },
    {
      title: "Tailored Strategies for Every Need",
      icon: "blue-circle-setting",
      description:
        "From strategy to execution, we stand by you, offering hands-on support and ongoing follow-ups to ensure long-term success.",
    },
  ];
  return (
    <div className="bg-custom-white pt-10 sm:pt-12 md:pt-16 lg:py-16 xl:py-20 relative flex flex-col-reverse gap-y-10 sm:gap-y-14 md:gap-y-20 max-sm:overflow-clip">
      <img
        className="absolute -top-5 sm:-top-6 md:-top-10 lg:-top-16 right-0 w-full max-w-[120.02px] max-xl:max-w-24 max-md:max-w-16"
        src={leafImg}
        alt="leaf content"
      />
      <img
        src={layer}
        className="lg:absolute top-0 left-0 w-full max-lg:max-h-[840px] lg:w-[43.7%] h-full object-cover"
        alt="a hand with bulb on palm "
      />
      <div className="flex justify-end container">
        <div className="w-full lg:w-[53.5%] xl:w-[51.5%]">
          <div className="">
            <BlueTag>Why Choose Us</BlueTag>
            <Heading className="max-lg:max-w-[550px]  pt-1">
              Your Partner in Innovation and Excellence
            </Heading>
            <Paragraph className="mt-3">
              At Make Way India, we strive to transform your ideas into
              impactful realities. With a proven track record, we are your
              trusted partner, delivering innovative solutions tailored to your
              needs and setting new benchmarks for success.
            </Paragraph>
            <div className="flex flex-col gap-y-4 pt-6 text-left">
              {list.map((obj, index) => (
                <Card key={index} obj={obj} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseUs;
